import { render, staticRenderFns } from "./BeefCattleSmallList2.vue?vue&type=template&id=2573945c&scoped=true"
import script from "./BeefCattleSmallList2.vue?vue&type=script&lang=js"
export * from "./BeefCattleSmallList2.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleSmallList2.vue?vue&type=style&index=0&id=2573945c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573945c",
  null
  
)

export default component.exports